import { render, staticRenderFns } from "./carruselDashboard.vue?vue&type=template&id=da9bf424&scoped=true"
import script from "./carruselDashboard.vue?vue&type=script&lang=js"
export * from "./carruselDashboard.vue?vue&type=script&lang=js"
import style0 from "./carruselDashboard.vue?vue&type=style&index=0&id=da9bf424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9bf424",
  null
  
)

export default component.exports